import React from 'react';

type MapPinProps = {
  width?: number;
  height?: number;
  fill?: string;
  border?: string;
  inner?: string;
  borderWidth?: number;
};

export const MapPin = ({
                         width = 34,
                         height = 40,
                         fill = "#E53935",
                         border = "#2E7D32",
                         inner = "#FBC02D",
                         borderWidth = 2
                       }: MapPinProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 40"
      style={{
        cursor: "pointer",
        filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
      }}
    >
      <path
        d="M17 2 C10.8 2 6 7.2 6 14 c0 8.5 11 22 11 22 s11-13.5 11-22 C28 7.2 23.2 2 17 2z"
        fill={fill}

      />
      <path
        d="M17 2 C10.8 2 6 7.2 6 14 c0 8.5 11 22 11 22 s11-13.5 11-22 C28 7.2 23.2 2 17 2z"
        fill="none"
        stroke={border}
        strokeWidth={borderWidth}
      />
      <circle
        cx="17"
        cy="13.5"
        r="4.5"
        fill={inner}
        stroke={border}
        strokeWidth="1"
      />

    </svg>
  )

};